module.exports = __webpack_public_path__ + "static/media/organizin.7cae00a1.svg";